import { useEffect, useState } from "react";
import { useFormInternalContext } from "../../visual/FormProvider/formContext.js";
function useForm() {
  const { api } = useFormInternalContext();
  const [{ values, errors, meta, fields }, setFormState] = useState(() => {
    return {
      values: api.getValues(),
      errors: api.getErrors(),
      meta: api.getMeta(),
      fields: api.getFields()
    };
  });
  useEffect(() => {
    let effectCleared = false;
    const unsubscribe = api.subscribeToForm((formApi) => {
      if (effectCleared) return;
      setFormState({
        values: formApi.getValues(),
        errors: formApi.getErrors(),
        meta: formApi.getMeta(),
        fields: formApi.getFields()
      });
    });
    return () => {
      effectCleared = true;
      unsubscribe();
    };
  }, [api]);
  return { values, errors, meta, fields, api };
}
export {
  useForm
};
//# sourceMappingURL=useForm.js.map
